import { render, staticRenderFns } from "./Festivos.vue?vue&type=template&id=50e154f4&"
import script from "./Festivos.vue?vue&type=script&lang=js&"
export * from "./Festivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports